// >>>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>
import React from "react";

export default function Contact() {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Contact</h1>
      <p>
        If you need help with StockVisualize, have feedback, or want to report a
        technical issue, you can reach us at:
      </p>

      <p>
        <strong>Email:</strong> stock.visualise@gmail.com
      </p>

      <p>We typically respond within 72 hours.</p>
    </div>
  );
}
// <<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<<
